import type { StoryblokTable } from '@cinch-nx/data-storyblok'

import styles from './cookie-policy-table.module.css'

export type Props = {
  table: StoryblokTable
  dontShowTableHeader?: boolean
}

const isThirdParty = (index: number, thirdPartyCol: string): boolean =>
  index === 1 && thirdPartyCol.toLowerCase() === '3rd party'

export const CookiePolicyTable: React.FC<Props> = ({
  table,
  dontShowTableHeader,
}) => {
  const head = table.thead.filter((head, index) => index !== 2)
  const body = table.tbody
  return (
    <table className={styles.table} data-testid="cookie-policy-table">
      {!dontShowTableHeader && (
        <thead>
          <tr>
            {head.map((heading) => (
              <th key={heading._uid}>{heading.value}</th>
            ))}
          </tr>
        </thead>
      )}
      <tbody>
        {body.map((row, rowIndex) => (
          <tr key={row._uid}>
            {row.body
              .filter((cell, index) => index !== 2)
              .map((cell, index) =>
                isThirdParty(index, `${row.body[3].value}`) ? (
                  <td key={cell._uid}>
                    <a
                      href={row.body[2].value as string}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {cell.value}
                    </a>
                  </td>
                ) : (
                  <td key={cell._uid}>{cell.value}</td>
                ),
              )}
          </tr>
        ))}
      </tbody>
    </table>
  )
}
